import { ReactElement } from 'react';
import { Box } from 'ink';
import { GitLabLogo } from './GitLabLogo';

export interface AppHeaderProps {
  cwd?: string;
  children: ReactElement;
  /**
   * Terminal width. Required because the header is rendered inside Ink's
   * `<Static>`, which does not constrain box width like the normal layout tree.
   * Used to wrap the info column and to hide the logo on narrow terminals.
   */
  columns: number;
}

// Below this width the GitLab logo is dropped so the info column has room to
// wrap instead of overflowing the terminal.
const MIN_WIDTH_FOR_LOGO = 60;

export const AppHeader: React.FC<AppHeaderProps> = ({ children, columns }) => {
  const showLogo = columns >= MIN_WIDTH_FOR_LOGO;

  return (
    <Box width={columns} marginTop={1} alignItems="center">
      {showLogo && (
        <Box flexShrink={0} marginRight={1}>
          <GitLabLogo />
        </Box>
      )}
      {/* Divider lives on the text column's left border, so it spans exactly the
          text height (grows when the project URL wraps) instead of the row. */}
      <Box
        flexDirection="column"
        flexGrow={1}
        flexShrink={1}
        minWidth={0}
        paddingLeft={showLogo ? 1 : 0}
        borderStyle="round"
        borderTop={false}
        borderRight={false}
        borderBottom={false}
        borderLeft={showLogo}
      >
        {children}
      </Box>
    </Box>
  );
};
